<template>
    <div>
        <div class="main-content__row">
            <p>К сожалению оплата вашего заказа прошла не успешно,</p>
            <p>Пожалуйста обратитесь к администратору</p>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex'

    /* global WecanGtm */
    export default {
        mounted() {
            let self = this
            setTimeout(function () {
                self.sendInfoToGtm()
            }, 2000)
        },
        beforeMount() {
            if (this.$router.currentRoute.params.eventId) {
                this.setCurrentEventId(this.$router.currentRoute.params.eventId);
                this.getEvent();
            }
        },
        data: function () {
            return {
                emptyBlank: true
            }
        },
        watch: {
            self: function () {
                this.blank.friends = '';
            }
        },
        methods: {
            sendInfoToGtm: function () {
                WecanGtm.purchase(
                    this.order.id,
                    window.location.hostname,
                    this.order.sum,
                    this.order.certificate_code?? this.order.promocode,
                    this.currentEvent.name,
                    this.currentEvent.direction_id,
                    process.env.VUE_APP_GTM_CATEGORY,
                    this.order.person_count,
                    'N/A',
                    this.currentEvent.currency
                )
            },
            submit: function () {
                if (!this.isError) {
                    this.saveBlank(this.blank);
                }
            },
            ...mapActions([
                'saveBlank',
                'getEvent'
            ]),
            ...mapMutations([
                'setCurrentEventId'
            ])
        },
        computed: {
            isError: function () {
                let errors = 0;

                for (let a in this.blank) {
                    if (a != 'friends') {
                        if (a != 'self' && !this.blank[a]) {
                            errors++;
                        }
                    } else {
                        if (!this.blank[a] && !this.blank['self']) {
                            errors++;
                        }
                    }
                }

                return errors;
            },
            self: function () {
                return this.blank.self;
            },
            ...mapState([
                'currentEvent',
                'blankSaved',
                'blank',
                'order',
            ])
        }
    }
</script>
<style>
    .field-friends {
        padding-top: 20px;
    }

    .success {
        color: green;
        font-size: 14px;
    }
</style>
